<template>
  <div class="filter-group">
    <div class="filter-keyword">
      <el-input
        size="mini"
        :placeholder="`请输入${itemDataFilter.placeholder}`"
        prefix-icon="el-icon-search"
        v-model="keyword"
        clearable
        @clear="searchListData"
        @input="inputSearch"
        @keyup.enter.native="searchListData"
      />
    </div>
    <div v-if="isShowTitle" class="filter-title">{{ itemDataFilter.key }}</div>
    <div class="filter-list" @scroll="listScroll">
      <div
        v-for="(item, index) in listChild"
        :key="index"
        :class="{ 'filter-item': true, active: item.is_choose }"
        @click="itemToggle(item)"
      >
        <div class="filter-name">
          <span>{{ item.key }}</span>
          <span v-if="isShowCount">({{ item.count }}) </span>
        </div>
        <i v-show="item.is_choose" class="el-icon-check" />
      </div>
    </div>
    <div v-if="!isShowTitle" class="filter-more">
      <template v-if="loading">
        <i class="el-icon-loading" />
        <span>加载中</span>
      </template>
      <template v-if="!loading">
        <span v-if="pageOptions.lastPage">已经到最底部啦</span>
        <el-link v-else v-debounce="listLoadNextPage">滚动加载下一页</el-link>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    init_filter_data: {
      type: Object,
      required: true
    },
    isShowTitle: {
      type: Boolean,
      default: false
    },
    itemDataFilter: {
      type: Object,
      required: true
    },
    listActiveFilter: {
      type: Array,
      default: () => {
        return []
      }
    },
    click_key: {
      type: String,
      default: ''
    },
    search_data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      toggleing: false,
      timer: null,
      pageOptions: {
        currentPage: 1,
        lastPage: false
      },
      keyword: '',
      listChild: []
    }
  },
  computed: {
    isShowCount() {
      let result = false
      result = this.init_filter_data.hide_count_keys.every((item) => {
        return item !== this.itemDataFilter.key
      })
      return result
    },
    listTopCount() {
      let result = this.isShowTitle ? '64px' : '38px'
      return result
    },
    listBottomCount() {
      let result = this.isShowTitle ? '0' : '26px'
      return result
    }
  },
  watch: {
    'itemDataFilter.active': {
      handler(val) {
        this.listChild.forEach((itemSt) => {
          let is_choose = val.some((itemNd) => {
            let isChoose = itemSt.field === itemNd.field && itemSt.key === itemNd.key
            return isChoose
          })
          itemSt.is_choose = is_choose
        })
      },
      immediate: true,
      deep: true
    },
    listActiveFilter: {
      handler() {
        this.searchListData()
        // let len = newVal.length
        // if (len) {
        //   if (this.itemDataFilter.key !== this.click_key) {
        //     // 切换项时，如果当前项不等于点击项，则重置当前项数据并搜索列表数据
        //     this.searchListData()
        //   }
        // } else {
        //   this.searchListData()
        // }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取列表数据
    async getListData() {
      this.loading = true
      let params = {
        search_type: this.itemDataFilter.search_type,
        field: this.itemDataFilter.field,
        keyword: this.keyword,
        currentPage: this.pageOptions.currentPage,
        pageSize: 50
      }

      // 补充搜索参数
      Object.keys(this.search_data).forEach((key) => {
        let val = this.search_data[key]
        if (typeof val === 'string' && val.trim()) params[key] = val
        if (typeof val === 'number' && !isNaN(val)) params[key] = val
        if (Array.isArray(val) && val.length) params[key] = val
      })

      // 补充左侧筛选参数
      if (this.listActiveFilter.length) params.left_filter = this.listActiveFilter

      await this.$api({
        method: 'post',
        url: this.init_filter_data.api_url_child,
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let allData = []
            let oldData = this.$util.deepCopy(this.listChild)
            let newData = this.$util.deepCopy(res.data.data)
            newData.list.forEach((item) => {
              item.field = this.itemDataFilter.field
              item.search_type = this.itemDataFilter.search_type
            })
            allData = [...oldData, ...newData.list]

            allData.forEach((itemSt) => {
              let is_choose = this.itemDataFilter.active.some((itemNd) => {
                let isChoose = itemSt.field === itemNd.field && itemSt.key === itemNd.key
                return isChoose
              })
              itemSt.is_choose = is_choose
            })

            this.listChild = this.$util.deepCopy(allData)
            this.pageOptions.currentPage = newData.pageNumber
            this.pageOptions.lastPage = newData.lastPage
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 搜索列表数据
    searchListData() {
      this.listChild = []
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 输入-搜索
    inputSearch() {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.searchListData()
        this.timer = null
      }, 500)
    },

    // 列表-滚动
    listScroll(event) {
      const container = event.target
      const { scrollTop, scrollHeight, clientHeight } = container
      // 距离底部 28px 时触发
      let isBottom = scrollTop + clientHeight >= scrollHeight - 28
      let isLoadNextPage = !this.loading && !this.pageOptions.lastPage && isBottom
      if (isLoadNextPage) this.listLoadNextPage()
    },
    // 列表-加载下一页
    listLoadNextPage() {
      this.pageOptions.currentPage++
      this.getListData()
    },
    // 项-切换
    itemToggle(item) {
      if (!this.toggleing) {
        this.toggleing = true
        let result = this.$util.deepCopy(this.itemDataFilter)
        let data = item
        if (data.is_choose) {
          this.itemDataFilter.active.forEach((item, index) => {
            let isRepeat = item.field === data.field && item.key === data.key
            if (isRepeat) {
              data.is_choose = false
              result.active.splice(index, 1)
            }
          })
        } else {
          data.is_choose = true
          data.sort_time = new Date().getTime()
          result.active.push(this.$util.deepCopy(data))
        }
        this.$emit('success', result)
        setTimeout(() => {
          this.toggleing = false
        }, 500)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.filter-group {
  position: relative;
  flex: 1;
  color: @colorGray;
  & ~ .filter-group {
    border-top: @border;
  }
  .filter-keyword {
    padding: 5px;
  }
  .filter-title {
    font-weight: bold;
    line-height: 16px;
    padding: 5px;
    cursor: pointer;
  }
  .filter-list {
    position: absolute;
    left: 0;
    right: 0;
    top: v-bind(listTopCount);
    bottom: v-bind(listBottomCount);
    line-height: 16px;
    overflow-y: auto;
    .scroll-bar();
    .filter-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px;
      & ~ .filter-item {
        border-top: 1px solid @colorWhite;
      }
      &:hover,
      &.active {
        color: @colorBlue;
        background: @colorBlue20;
        cursor: pointer;
      }
      .filter-name {
        width: 120px;
      }
    }
  }
  .filter-more {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 16px;
    padding: 5px 0;
    border-top: @border;
  }
}
</style>
